import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const titleLoadingSpinnerStyles = css`
  margin-left: 8px;
`;

export const titleStyles = css`
  color: ${withVar(DesignToken.ContentBasicPrimary)};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
`;

export const headerStyles = css`
  display: flex;
  align-items: center;
  min-height: 34px;
`;
